import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/components/common/Home.vue'
import Editor from '@/views/Editor.vue'
import e404 from '@/views/404.vue'
import e403 from '@/views/403.vue'
import Login from '@/views/Login.vue'
import test from '@/views/test.vue'
import Dashboard from '@/views/Dashboard.vue'
import BBS from '@/views/BBS.vue'
import BBSEdit from '@/views/BBSEdit.vue'
import BBSAnswerEdit from '@/views/BBSAnswerEdit.vue'
import BBSDetail from '@/views/BBSDetail.vue'
import AccountManage from '@/views/AccountManage.vue'
import LoginInfo from '@/views/LoginInfo.vue'
import SystemNotice from '@/views/SystemNotice.vue'
import ToolsError from '@/views/ToolsError.vue'
import NormalSetting from '@/views/NormalSetting.vue'
import VersionControl from '@/views/VersionControl.vue'
import ToolVersionUpdate from '@/views/ToolVersionUpdate.vue'
import PersonalCenter from '@/views/PersonalCenter.vue'
import DateTable from '@/views/DateTable.vue'

const routes = [
  {
    path: '/ATS',
    redirect: '/ATS/dashboard'
  },
  {
    path: '/ATS',
    name: 'Home',
    component: Home,
    meta: { title: 'Home' },
    children: [
      {
        path: '/ATS/dashboard',
        name: 'DateTable',
        component: DateTable,
        meta: { title: 'Dashboard' }
      },
      {
        path: '/ATS/BBS',
        name: 'BBS',
        component: BBS,
        meta: { title: 'BBS' }
      },
      {
        path: '/ATS/BBSEdit',
        name: 'BBSEdit',
        component: BBSEdit,
        meta: { title: 'BBSEdit' }
      },
      {
        path: '/ATS/BBSAnswerEdit',
        name: 'BBSAnswerEdit',
        component: BBSAnswerEdit,
        meta: { title: 'BBSAnswerEdit' }
      },
      {
        path: '/ATS/BBSDetail',
        name: 'BBSDetail',
        component: BBSDetail,
        meta: { title: 'BBSDetail' }
      },
      {
        path: '/ATS/AccountManage',
        name: 'AccountManage',
        component: AccountManage,
        meta: { title: 'AccountManage' }
      },
      {
        path: '/ATS/LoginInfo',
        name: 'LoginInfo',
        component: LoginInfo,
        meta: { title: 'LoginInfo' }
      },
      {
        path: '/ATS/SystemNotice',
        name: 'SystemNotice',
        component: SystemNotice,
        meta: { title: 'SystemNotice' }
      },
      {
        path: '/ATS/ToolsError',
        name: 'ToolsError',
        component: ToolsError,
        meta: { title: 'ToolsError' }
      },
      {
        path: '/ATS/NormalSetting',
        name: 'NormalSetting',
        component: NormalSetting,
        meta: { title: 'NormalSetting' }
      },
      {
        path: '/ATS/VersionControl',
        name: 'VersionControl',
        component: VersionControl,
        meta: { title: 'VersionControl' }
      },
      {
        path: '/ATS/ToolVersionUpdate',
        name: 'ToolVersionUpdate',
        component: ToolVersionUpdate,
        meta: { title: 'ToolVersionUpdate' }
      },
      {
        path: '/ATS/PersonalCenter',
        name: 'PersonalCenter',
        component: PersonalCenter,
        meta: { title: 'PersonalCenter' }
      },
      {
        path: '/ATS/Welcome',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: 'Dashboard' }
      },
    ]
  },
  {
    path: '/ATS/Editor',
    name: 'Editor',
    component: Editor
  },
  {
    path: '/ATS/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/ATS/404',
    name: '404',
    component: e404
  },
  {
    path: '/ATS/403',
    name: '403',
    component: e403
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/ATS/404'
  },
  {
    path: '/ATS/test',
    name: 'test',
    component: test
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
